import { Card, ClearProviders, Heading, HeadingContext, Inline, Spinner, Stack, Text } from "@hopper-ui/components";
import { SuccessIcon } from "@hopper-ui/icons";
import { type InitializingCategoryKey, InitializingCategoryTitles } from "../../api/crawlCategories.ts";
import { type TenantCrawlOverviewDto } from "../../api/types.ts";
import { Progress } from "@sg-protect/components";

export interface ScanCardProps {
    tenant: TenantCrawlOverviewDto;
    categoryKeys: readonly InitializingCategoryKey[];
}

export function ScanCard({ tenant, categoryKeys }: ScanCardProps) {
    const completedCount = categoryKeys.filter(key => !tenant[key]).length;

    return (
        <Card padding="inset-md">
            <Stack gap="stack-sm">
                <ClearProviders values={[HeadingContext]}>
                    <Heading level={4} size="xs" data-public>
                        Scanning tenant
                    </Heading>
                </ClearProviders>
                <Progress
                    value={completedCount}
                    max={categoryKeys.length}
                    fillColor="primary-strong"
                    aria-label="Scan progress"
                />
                <Stack gap="stack-sm" marginTop="stack-sm">
                    {categoryKeys.map(key => {
                        const isCategoryScanning = tenant[key];

                        return (
                            <Inline key={key} gap="inline-sm" color="neutral">
                                {isCategoryScanning ? (
                                    <Spinner size="sm" aria-label="Scanning tenant…" />
                                ) : (
                                    <SuccessIcon size="sm" color="success-weak" />
                                )}
                                <Text size="sm">{InitializingCategoryTitles[key]}</Text>
                            </Inline>
                        );
                    })}
                </Stack>
            </Stack>
        </Card>
    );
}
